// 签到功能模块api
import { request } from "@/utils/request";

// 获取考勤配置
/**
 *   "data": {
    "signConfId": "1806001325050286081",
    "websiteId": "1492050548817203202",
    "signConfMonth": "202405",
    "signAddress": "南昌市西湖区桃苑中路88号朝阳锦城住宅小区A栋一楼店面",
    "signAddressRanage": 100,
    "signAddressLat": "115.891023",
    "signAddressLon": "28.660074",
    "daySignInCount": 0
  }
 */
export function getSignConfigInfo() {
  return request({
    url: "/employee/signConf/1.0/info",
    method: "POST",
  });
}

// 签到
export function signIn(params) {
  return request({
    url: "/employee/signIn/1.0/signIn",
    method: "POST",
    params,
  });
}
// 网点统计
export function webSiteList(params) {
  return request({
    url: "/employee/signIn/1.0/websiteList",
    method: "POST",
    params,
  });
}
// 个人统计
export function personList(params) {
  return request({
    url: "/employee/signIn/1.0/personList",
    method: "POST",
    params,
  });
}

//签到审批列表
export function getApproveList(params) {
  return request({
    url: "/employee/signIn/1.0/signAuditList",
    method: "POST",
    params,
  });
}
// 签到详情
export function getSignInfo(params) {
  return request({
    url: "/employee/signIn/1.0/signInfo",
    method: "POST",
    params,
  });
}
// 签到审批
export function signApprove(params) {
  return request({
    url: "/employee/signIn/1.0/signAudit",
    method: "POST",
    params,
  });
}
